import React from "react";
import "./dashboardStyling.js";
import DashboardHeader from "../includes/dashboardHeader/DashboardHeader";
import DashboardSidebar from "../includes/dashboardSidebar/DashboardSidebar";
import DashboardBox from "./subComponent/dashboardBox/DashboardBox";
// import NewsSection from "./subComponent/newsSection/NewsSection";
// import AnnouncementSection from "./subComponent/announcementSection/AnnouncementSection";
// import PopularResources from "./subComponent/popularResources/PopularResources";
// import ScrippsStrategicGoals from "./subComponent/scrippsStrategicGoals/scrippsStrategicGoals";
// import Webinar from "./subComponent/webinar/Webinar";
// import TodoList from "./subComponent/todoList/TodoList";
import FooterComponent from '../includes/dashboardFooter/FooterComponent';
// import AsideComponent from '../includes/asideComponent/AsideComponent';
import SidebarJs from '../../common/js/sidebarAnimation';
import { connect } from "react-redux";
import { fetchDashboardData, fetchAMPercentagevalue, fetchCMPercentageValue } from "../../actions/dashboardDataActions"
import { fetchBenchmarkProjects } from '../../actions/questionaireActions';
import { fetchProjects } from '../../actions/capabilityActions';
import ModuleAnalyticsBox from "./subComponent/analytics/ModuleAnalyticsBox";
import { Grid } from "@material-ui/core";
import { withRouter } from "react-router-dom";


import axios from 'axios';
import { responseMessage } from '../../utils/alert';
import CacheStorage from '../../utils/CacheStorage';
const config = require('../../config');

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.sidebarAnimation = new SidebarJs();
    this.state = {
      projects: []
    }

  }
  async componentDidMount() {
    this.sidebarAnimation.toggle();
    this.setState({ loading: true });
    console.log("componentDidMount...")
    try {
      const userType = CacheStorage.getItem("userType");
      const userEmail = CacheStorage.getItem("userEmail") || localStorage.getItem("userEmail");
      const projectSelection = sessionStorage.getItem('projectSelection');

      // Only redirect if Super Admin AND no project selected
      if (String(userType) === "1" &&
        userEmail && userEmail.toLowerCase() === "superadmin@amplo.com" &&
        !projectSelection) {
        console.warn("No project context selected for Super Admin. Redirecting to selection screen...");
        this.props.history.push('/project-selection');
        return;
      }

      let amProjectId = 0;
      let cmProjectId = 0;
      let headers = {};

      if (String(userType) === "1" && userEmail && userEmail.toLowerCase() === "superadmin@amplo.com") {
        if (projectSelection) {
          try {
            const projSel = JSON.parse(projectSelection);
            if (projSel.ampProject?.BMProjectID) {
              amProjectId = projSel.ampProject.BMProjectID;
            }
            if (projSel.capProject?.DecompositionProjectID) {
              cmProjectId = projSel.capProject.DecompositionProjectID;
            }
            // Construct headers
            if (projSel.client?.user_id || projSel.client?.UserID) {
              headers['x-user-id'] = projSel.client.user_id || projSel.client.UserID;
            }
            if (projSel.client?.company_id || projSel.client?.CompanyID) {
              headers['x-company-id'] = projSel.client.company_id || projSel.client.CompanyID;
            }
          } catch (e) {
            console.error("Error parsing projectSelection", e);
          }
        }
      }

      // Kick off multiple API calls
      await Promise.all([
        this.props.fetchDashboardData(headers),
        this.props.fetchAMPercentagevalue(amProjectId, headers),
        this.props.fetchCMPercentageValue(cmProjectId, headers),
        this.props.fetchProjects(headers)
      ]);

      let projects = await axios.get(config.laravelBaseUrl + 'get_user_bm_projects', {
        headers: {
          "authorization": "Bearer " + CacheStorage.getItem("userToken"),
          ...headers
        }
      });

      this.props.fetchBenchmarkProjects(projects);

      let itemsResp = await axios.get(config.laravelBaseUrl + 'get_decomposition_user_projects', {
        headers: {
          "authorization": "Bearer " + CacheStorage.getItem("userToken"),
          ...headers
        }
      });

      let fetchedProjects = projects?.data?.data || [];
      let fetchedItems = itemsResp?.data?.data || [];

      if (fetchedProjects.length > 0) {

        // Determie IDs to use
        let selectedBMId = fetchedProjects[0].BenchmarkProjectID;
        let selectedDepId = fetchedItems?.[0]?.DecompositionProjectID || CacheStorage.getItem("DecompositionProjectID");

        // Override if Super Admin and we found IDs in projectSelection
        if (amProjectId > 0) selectedBMId = amProjectId;
        if (cmProjectId > 0) selectedDepId = cmProjectId;

        this.setState({
          currentProject: selectedBMId,
        });

        if (fetchedItems?.[0]?.DecompositionProjectID && cmProjectId === 0) {
          CacheStorage.setItem("DecompositionProjectID", fetchedItems[0].DecompositionProjectID);
        }

        // ✅ Fetch analytics for Capability Modeling
        if (selectedDepId) {
          const analyticsResp = await axios.get(
            `${config.laravelBaseUrl}dashboard/analytics/CM/${selectedBMId}/${selectedDepId}`,
            {
              headers: {
                "authorization": "Bearer " + CacheStorage.getItem("userToken"),
                ...headers
              }
            }
          );
          // Set analytics data
          this.setState({ analyticsData: analyticsResp.data.data });
        }
      }



      // ✅ only now stop loader
      this.setState({ loading: false });
      this.sidebarAnimation.toggle();

    } catch (error) {
      this.setState({ loading: false });
      if (error.response) return;
      responseMessage("error", "Something Went Wrong!", "");
      throw error;
    }
  }

  getAMPercentage = (projectId) => {
    this.props.fetchAMPercentagevalue(projectId);
  }

  getCMPercentage = (projectId) => {
    this.props.fetchCMPercentageValue(projectId);
  }

  calcCompletionStats = (rawData) => {
    if (!rawData || rawData.length === 0) return [];

    const totalScored = rawData.reduce(
      (sum, d) => sum + Number(d.ScoredCapabilities || 0),
      0
    );
    const totalCaps = rawData.reduce(
      (sum, d) => sum + Number(d.TotalCapabilities || 0),
      0
    );

    const pct =
      totalCaps > 0 ? Math.round((totalScored / totalCaps) * 100) : 0;

    return [
      {
        label: "Total Completion",
        value: pct,
        color: pct === 100 ? "green" : "orange",
      },
    ];
  };




  render() {
    return [
      <DashboardHeader key="header"></DashboardHeader>,
      <div id="wrapper" key="body-wrapper">
        <DashboardSidebar></DashboardSidebar>
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <ol className="breadcrumb dashbread">
              <li className="breadcrumb-item active"></li>
              <li className="breadcrumb-menu d-md-down-none ml-auto">
                {<img src={require('./../../common/images/AmploFooter.svg')} className="logo-img" alt="Logo" />}
                <a className="btn powered p-0" href="#">
                  &nbsp;<i>Powered by Amploglobal</i>
                </a>

              </li>
            </ol>
            <div className="container-fluid container-dashboard mt-3">

              <DashboardBox
                getAMPercentage={(projectId) => this.getAMPercentage(projectId)}
                AMPercentageValue={this.props.AMPercentageValue}
                getCMPercentage={(projectId) => this.getCMPercentage(projectId)}
                CMPercentageValue={this.props.CMPercentageValue}
                AMdata={this.props.projects}
                CMdata={this.props.items}
                highlight={this.props.dashboardItems ? this.props.dashboardItems.dashBoardHighlight : null}></DashboardBox>

              {/* here we need analytics of each module*/}

              <Grid container spacing={3} style={{ marginTop: "10px", marginBottom: "5rem" }}>
                {/* 1. Organization Structure - Bar Chart */}
                <Grid item xs={12} md={6} lg={4}>
                  <ModuleAnalyticsBox
                    title="Organization Structure"
                    chartType="bar"
                    hideLegend={true}
                    chartData={{
                      labels: ["Company", "Entity", "Unit"],
                      datasets: [
                        {
                          data: [
                            this.state.analyticsData?.organizationStructure?.ParentCount || 0,
                            this.state.analyticsData?.organizationStructure?.EntityCount || 0,
                            this.state.analyticsData?.organizationStructure?.OperatingUnitCount || 0,
                          ],
                          backgroundColor: ["#42a5f5", "#66bb6a", "#ffa726"],
                          barThickness: 30,
                          maxBarThickness: 40,
                          borderRadius: 8,
                        },
                      ],
                    }}
                    stats={[
                      {
                        label: "Company",
                        value: this.state.analyticsData?.organizationStructure?.ParentCount || 0,
                        color: "#42a5f5",
                      },
                      {
                        label: "Entity",
                        value: this.state.analyticsData?.organizationStructure?.EntityCount || 0,
                        color: "#66bb6a",
                      },
                      {
                        label: "Unit",
                        value: this.state.analyticsData?.organizationStructure?.OperatingUnitCount || 0,
                        color: "#ffa726",
                      },
                    ]}
                    actions={[
                      {
                        label: "View Entities",
                        onClick: () => this.props.history.push("/new-entity"),
                      },
                      {
                        label: "View Operating Units",
                        onClick: () => this.props.history.push("/new-unit"),
                      },
                    ]}
                  />
                </Grid>

                {/* 2. AmpMarking - Bar Chart */}
                <Grid item xs={12} md={6} lg={8}>
                  <ModuleAnalyticsBox
                    title="AmpMarking"
                    chartType="bar"
                    hideLegend={false}
                    chartData={{
                      labels: this.state.analyticsData?.ampMarking?.map(d => d.DomainName) || [],
                      datasets: [
                        {
                          label: "Total Questions",
                          data: this.state.analyticsData?.ampMarking?.map(d => d.TotalQuestions) || [],
                          backgroundColor: this.state.analyticsData?.ampMarking?.map((_, i) => {
                            const colors = ["#00316E"];
                            return colors[i % colors.length];
                          }) || [],
                          barThickness: 30,
                          maxBarThickness: 40,
                          borderRadius: 8,
                        },
                        {
                          label: "Answered",
                          data: this.state.analyticsData?.ampMarking?.map(d => d.Answered) || [],
                          backgroundColor: this.state.analyticsData?.ampMarking?.map((_, i) => {
                            const colors = ["#FFA91E"];
                            return colors[i % colors.length];
                          }) || [],
                          barThickness: 30,
                          maxBarThickness: 40,
                          borderRadius: 8,
                        },
                      ],
                    }}
                    chartOptions={{
                      indexAxis: "y",
                      plugins: {
                        legend: { position: "bottom" },
                      },
                      scales: {
                        x: {
                          stacked: false,
                          title: { display: true, text: "Questions" },
                        },
                        y: { stacked: false },
                      },
                    }}
                    stats={
                      this.state.analyticsData?.ampMarking?.map(d => ({
                        label: d.DomainName,
                        value: `${Number(d.CompletionPercentage || 0)}%`,
                        color: "#1976d2",
                      })) || []
                    }
                    actions={[
                      {
                        label: "Assesment",
                        onClick: () => this.props.history.push("/benchmark-questionaire"),
                      },
                      // {
                      //   label: "Goal Setting",
                      //   onClick: () => this.props.history.push("/new-unit"),
                      // },
                    ]}
                  />
                </Grid>

                {/* 3. Capability Modeling - Heatmap */}
                <Grid item xs={12} md={12} lg={12}>
                  <ModuleAnalyticsBox
                    title="Capability Modeling"
                    chartType="matrix"
                    chartData={{ raw: this.state.analyticsData?.capabilityModeling }}
                    stats={this.calcCompletionStats(this.state.analyticsData?.capabilityModeling)}
                  />
                </Grid>

                {/* 4. Performance Measuring - Stacked Bar */}
                <Grid item xs={12} md={6} lg={4}>
                  <ModuleAnalyticsBox
                    title="Performance Measuring"
                    chartType="bar"
                    hideLegend={true}
                    chartData={{
                      labels: ["Active", "Configured", "Defined"],
                      datasets: [
                        {
                          data: [
                            this.state.analyticsData?.performanceMeasuring[0]?.Active || 0,
                            this.state.analyticsData?.performanceMeasuring[0]?.Configured || 0,
                            this.state.analyticsData?.performanceMeasuring[0]?.Defined || 0,
                          ],
                          backgroundColor: ["#42a5f5", "#66bb6a", "#ffa726"],
                          barThickness: 30,
                          maxBarThickness: 40,
                          borderRadius: 8,
                        },
                      ],
                    }}
                    stats={[
                      {
                        label: "Active",
                        value: this.state.analyticsData?.performanceMeasuring[0]?.Active || 0,
                        color: "#42a5f5",
                      },
                      {
                        label: "Configured",
                        value: this.state.analyticsData?.performanceMeasuring[0]?.Configured || 0,
                        color: "#66bb6a",
                      },
                      {
                        label: "Defined",
                        value: this.state.analyticsData?.performanceMeasuring[0]?.Defined || 0,
                        color: "#ffa726",
                      },
                    ]}
                    actions={[
                      {
                        label: "View Entities",
                        onClick: () => this.props.history.push("/new-entity"),
                      },
                      {
                        label: "View Operating Units",
                        onClick: () => this.props.history.push("/new-unit"),
                      },
                    ]}
                  />
                </Grid>


                {/* 5. Data Management - bar Chart */}
                <Grid item xs={12} md={6} lg={4}>
                  <ModuleAnalyticsBox
                    title="Data Management"
                    chartType="bar"
                    hideLegend={true}
                    chartData={{
                      labels: ["Categories", "Files", "Templates"],
                      datasets: [
                        {
                          data: [
                            this.state.analyticsData?.dataManagement[0]?.TotalCategories || 0,
                            this.state.analyticsData?.dataManagement[0]?.TotalFiles || 0,
                            this.state.analyticsData?.dataManagement[0]?.TotalTemplates || 0,
                          ],
                          backgroundColor: ["#42a5f5", "#66bb6a", "#ffa726"],
                          barThickness: 30,
                          maxBarThickness: 40,
                          borderRadius: 8,
                        },
                      ],
                    }}
                    stats={[
                      {
                        label: "Categories",
                        value: this.state.analyticsData?.dataManagement[0]?.TotalCategories || 0,
                        color: "#42a5f5",
                      },
                      {
                        label: "Files",
                        value: this.state.analyticsData?.dataManagement[0]?.TotalFiles || 0,
                        color: "#66bb6a",
                      },
                      {
                        label: "Templates",
                        value: this.state.analyticsData?.dataManagement[0]?.TotalTemplates || 0,
                        color: "#ffa726",
                      },
                    ]}
                    actions={[
                      {
                        label: "Upload Data",
                        onClick: () => this.props.history.push("/data-management/report"),
                      },
                      {
                        label: "View Templates",
                        onClick: () => this.props.history.push("/data-management/category-dashboard"),
                      },
                    ]}
                  />
                </Grid>


                {/* 6. Carbon Management - Polar Area */}
                <Grid item xs={12} md={6} lg={4}>
                  <ModuleAnalyticsBox
                    title="Carbon Management"
                    unit="%"
                    chartType="pie"
                    chartData={{
                      labels: ["Completed", "Partial", "No Data"],
                      datasets: [
                        {
                          data: [
                            this.state.analyticsData?.carbonManagement[0]?.CompletedPercentage || 0,
                            this.state.analyticsData?.carbonManagement[0]?.PartialPercentage || 0,
                            this.state.analyticsData?.carbonManagement[0]?.NoDataPercentage || 0,
                          ],
                          backgroundColor: ["#66bb6a", "#ffa726", "#ef5350"],
                        },
                      ],
                    }}
                    stats={[
                      { label: "Completed", value: this.state.analyticsData?.carbonManagement[0]?.CompletedPercentage || 0, color: "#66bb6a" },
                      { label: "Partial", value: this.state.analyticsData?.carbonManagement[0]?.PartialPercentage || 0, color: "#ffa726" },
                      { label: "No Data", value: this.state.analyticsData?.carbonManagement[0]?.NoDataPercentage || 0, color: "#ef5350" },
                    ]}
                    actions={[{ label: "Emission Dashboard", onClick: () => this.props.history.push("/data-management/carbon-emission"), }]}
                  />
                </Grid>

                {/* <Grid item xs={12} md={6} lg={4}>
                  <ModuleAnalyticsBox
                    title="No Data Card"
                    unit=""
                    chartType=""
                    chartData={{
                      labels: [],
                      datasets: [

                      ],
                    }}
                  />
                </Grid> */}
              </Grid>

              {/* <div className="row pb-3">
                <div className="col-sm-6 col-lg-6">
                  <NewsSection newsResource={this.props.dashboardItems ? this.props.dashboardItems.industryNews : null}></NewsSection>
                  <AnnouncementSection announcements={this.props.dashboardItems ? this.props.dashboardItems.announcements : null}></AnnouncementSection>
                  <PopularResources resources={this.props.dashboardItems ? this.props.dashboardItems.popularResources : null}></PopularResources>
                  <ScrippsStrategicGoals></ScrippsStrategicGoals>
                </div>
                <Webinar webinars={this.props.dashboardItems ? this.props.dashboardItems.webinars : null}></Webinar>
                <TodoList todoList={this.props.dashboardItems ? this.props.dashboardItems.todo : null} events={this.props.dashboardItems ? this.props.dashboardItems.event : null}></TodoList>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      ,

      <FooterComponent key="footer"></FooterComponent>
    ];
  }
}
const mapStateToProps = state => ({
  dashboardItems: state.dashboardData.items,
  projects: state.questionaire.projects,
  domains: state.questionaire.domains,
  items: state.capability.items,
  AMPercentageValue: state.dashboardData.amPercentageVal,
  CMPercentageValue: state.dashboardData.cmPercentageVal,
});



export default connect(
  mapStateToProps,
  { fetchBenchmarkProjects, fetchDashboardData, fetchProjects, fetchAMPercentagevalue, fetchCMPercentageValue }
)(withRouter(Dashboard));
